import { useState } from 'react';

import { fmt } from '@dcc-erp/shared';
import { Icon } from '@dcc-erp/ui';

function today(): string {
  return new Date().toISOString().slice(0, 10);
}

export interface WriteOffPayload {
  writeOffDate: string;
  reason: string;
}

export function WriteOffModal({
  voucherNo,
  outstanding,
  busy,
  error,
  onConfirm,
  onClose,
}: {
  voucherNo: string;
  outstanding: number;
  busy: boolean;
  error: string | null;
  onConfirm: (p: WriteOffPayload) => void;
  onClose: () => void;
}) {
  const [writeOffDate, setWriteOffDate] = useState(today());
  const [reason, setReason] = useState('');
  const canSubmit = reason.trim().length > 0 && !busy;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,15,20,0.45)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 100,
        padding: 24,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: 12,
          width: 480,
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            padding: '18px 22px',
            borderBottom: '1px solid var(--border)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h3
            style={{ margin: 0, fontSize: 18, fontWeight: 600, fontFamily: 'var(--font-display)' }}
          >
            ตัดจำหน่ายเงินทดรอง
          </h3>
          <button className="btn ghost" onClick={onClose} style={{ padding: '0 8px' }}>
            <Icon name="x" size={18} />
          </button>
        </div>

        <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="meta">
            <b className="code">{voucherNo}</b> · ยอดคงค้าง{' '}
            <b className="tnum">{fmt(outstanding)}</b> บาท จะถูกตัดเป็นค่าใช้จ่าย (Dr
            ค่าใช้จ่ายเบ็ดเตล็ด / Cr เงินทดรอง)
          </div>
          <div>
            <label className="meta" style={{ display: 'block', marginBottom: 6 }}>
              วันที่ตัดจำหน่าย
            </label>
            <input
              className="input"
              type="date"
              aria-label="วันที่ตัดจำหน่าย"
              value={writeOffDate}
              onChange={(e) => setWriteOffDate(e.target.value)}
              style={{ width: '100%', height: 38 }}
            />
          </div>
          <div>
            <label className="meta" style={{ display: 'block', marginBottom: 6 }}>
              เหตุผล
            </label>
            <textarea
              className="input"
              aria-label="เหตุผล"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="เช่น พนักงานลาออกโดยไม่เคลียร์ / ยอดเล็กน้อยตัดจ่าย"
              style={{ width: '100%', padding: 10, resize: 'vertical' }}
            />
          </div>
          {error && (
            <div className="badge negative" style={{ fontSize: 13 }}>
              {error}
            </div>
          )}
        </div>

        <div
          style={{
            padding: '14px 22px',
            borderTop: '1px solid var(--border)',
            background: '#fafafa',
            display: 'flex',
            justifyContent: 'space-between',
            gap: 10,
          }}
        >
          <button className="btn ghost" onClick={onClose}>
            ยกเลิก
          </button>
          <button
            className="btn primary"
            disabled={!canSubmit}
            onClick={() => onConfirm({ writeOffDate, reason: reason.trim() })}
          >
            ตัดจำหน่าย
          </button>
        </div>
      </div>
    </div>
  );
}
